import React, { forwardRef, useState, useRef, useEffect, useImperativeHandle } from "react";
import Loader from "./loader";
import { InvisibleInfiniteLoader } from "./infiniteLoader";

type Props = {
	loadMore: () => Promise<any>;
	hasMore: boolean;
	children;
	onScroll?: () => void;
	loadMoreText?: string;
	isReverse?: boolean;
	className?: string;
};

const InfiniteScroll = ({ children, hasMore = false, loadMore, isReverse = false, className = null }: Props, ref) => {
	const [shouldLoad, setShouldLoad] = useState(false);
	const [loading, setLoading] = useState(false);

	const node = useRef<HTMLDivElement>(null as HTMLDivElement);

	useImperativeHandle(ref, () => ({
		scrollDown: () => {
			node.current.scrollTop = node.current.scrollHeight;
			node.current.scrollTo({
				top: node.current.scrollHeight,
				left: 0,
				behavior: "smooth",
			});
		},
	}));

	useEffect(() => {
		if (shouldLoad) {
			setLoading(true);
			loadMore().then(() => {
				setLoading(false);
			});
		}
	}, [shouldLoad]);

	const onViewChange = async (inView: boolean, observerEntry: IntersectionObserverEntry) => {
		const shouldLoad = inView && hasMore && !loading;
		setShouldLoad(shouldLoad);
	};

	return (
		<div ref={node} className={className}>
			{!isReverse ? children : null}
			{loading ? <Loader /> : hasMore ? <InvisibleInfiniteLoader onViewChange={onViewChange} /> : null}
			{isReverse ? children : null}
		</div>
	);
};

export default forwardRef(InfiniteScroll);
